module.exports = __webpack_public_path__ + "static/img/Inspection6.5a62642c.png";